import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews } from '../../components';

import css from './ListingPage.module.css';
import IconCollection from '../../components/IconCollection/IconCollection';

const SectionReviews = props => {
  const { reviews, fetchReviewsError } = props;

  const ratings = reviews
    .map(review => review?.attributes?.rating)
    .filter(rating => typeof rating === 'number' && !isNaN(rating));

  const totalReview = ratings.length;
  const averageRating =
    totalReview > 0 ? ratings.reduce((total, r) => total + r, 0) / totalReview : null;

  return (
    <section className={css.sectionReviews}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.reviewsTitle" values={{ count: reviews.length }} />

        {averageRating !== null && (
          <div className={css.ratingNaddress}>
            <div className={css.reviewContainer}>
              <IconCollection name="solidGoldenStar" />
              <span className={css.rating}>{Number(averageRating.toFixed(1))}</span>
              <span className={css.noOfReview}>({totalReview} reviews)</span>
            </div>
          </div>
        )}
      </Heading>

      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}

      <Reviews reviews={reviews} />
    </section>
  );
};

export default SectionReviews;
